import { mutatorAction } from 'satcheljs';
import type { AccountKey } from 'owa-client-types';
import type { OcpsPoliciesFetchState } from '../store/schema/OutlookCloudPoliciesSchema';
import getStore from '../store/store';

export const updateAccountFetchStateMutator: (
    accountKey: AccountKey,
    fetchState: OcpsPoliciesFetchState
) => void = mutatorAction(
    'updateAccountFetchState',
    (accountKey: AccountKey, fetchState: OcpsPoliciesFetchState): void => {
        const existing = getStore().get(accountKey);
        if (existing) {
            existing.fetchState = fetchState;
        } else {
            getStore().set(accountKey, { policies: {}, fetchState });
        }
    }
);
